import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api/client";
import { serverErrorMessage } from "@/lib/api/error-message";
import {
  broadcastPersonaSwitch,
  markPersonaSwitching,
  personaHomePath,
} from "@/lib/authv2/persona";
import type { PersonaOption } from "@/lib/authv2/store";

/**
 * Đổi danh phận trên máy này (QĐ 0255): máy chủ nhớ lựa chọn, rồi TẢI LẠI cả
 * trang về trang mở đầu của danh phận mới — menu, quyền, bộ nhớ đệm của mọi màn
 * dựng lại từ đầu, không màn nào giữ dữ liệu của danh phận cũ.
 */
export function usePersonaSwitch() {
  return useMutation({
    mutationFn: async (target: PersonaOption) => {
      markPersonaSwitching(true);
      try {
        const { error } = await api.PUT("/auth/me/persona", { body: { personaId: target.id } });
        if (error) throw new Error(serverErrorMessage(error, "Không đổi được danh phận"));
      } catch (e) {
        markPersonaSwitching(false);
        throw e;
      }
      return target;
    },
    onSuccess: (target) => {
      broadcastPersonaSwitch();
      window.location.assign(personaHomePath(target));
    },
    // Báo lỗi ở cấp hook, KHÔNG ở lời gọi mutate(): bấm một dòng là menu đóng
    // và khối menu rời khỏi màn — lời báo gắn vào mutate() sẽ không bao giờ
    // chạy, người dùng bấm mà không thấy gì.
    onError: (e) => toast.error(e instanceof Error ? e.message : "Không đổi được danh phận"),
  });
}
